import React from 'react'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { selectQueryParams } from 'selectors/location'
import { getValidDiscount } from 'subapps/onboarding/utils'
import { styles } from './styles'

const Heading = ({ className }) => {
  const query = useSelector(selectQueryParams)
  const { percentOff, durationInMonths } =
    getValidDiscount(query.discount) || {}
  const hasDiscount = percentOff && durationInMonths

  return (
    <div className={cn('grui text-center', className)}>
      {hasDiscount && (
        <div css={styles.promotion} className="grui mb-8 mx-auto">
          You&apos;ll get {percentOff}% off a Standard, Plus, or Pro Plan for{' '}
          {durationInMonths} months.
        </div>
      )}
      <h1
        className="grui m-0"
        css={[styles.title, hasDiscount && text.styles.fontNormal]}
      >
        Create your account
      </h1>
    </div>
  )
}

export default Heading
